import React from 'react'

export const createList = ({ list, setValue, callback, name }) => {
  return list.map((item, key) => (
    <div
      className="item"
      key={key}
      onClick={() => {
        if (callback) callback({ item, name })
        setValue(item)
      }}
    >
      <div className="text">{item.text || item.value}</div>
    </div>
  ))
}
